export const yearDateBounds = (year) => ({
  min: `${year}-01-01`,
  max: `${year}-12-31`
});

export const todayString = () => new Date().toISOString().slice(0, 10);

export const currentMonthRange = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');

  return {
    date_from: `${year}-${month}-01`,
    date_to: `${year}-${month}-${day}`
  };
};

export const lastDayOfMonth = (dateStr) => {
  if (!dateStr) {
    return null;
  }

  const [year, month] = dateStr.split('-').map(Number);
  const last = new Date(year, month, 0);

  return `${year}-${String(month).padStart(2, '0')}-${String(last.getDate()).padStart(2, '0')}`;
};

export const sameMonth = (d1, d2) => {
  if (!d1 || !d2) {
    return true;
  }

  return d1.slice(0, 7) === d2.slice(0, 7);
};

export const clampDateToYear = (date, year) => {
  if (!date || !year) {
    return null;
  }

  const { min, max } = yearDateBounds(year);

  if (date < min) {
    return min;
  }

  if (date > max) {
    return max;
  }

  return date;
};

export const clampDateRangeToYear = (dateFrom, dateTo, year) => ({
  date_from: clampDateToYear(dateFrom, year),
  date_to: clampDateToYear(dateTo, year)
});

export const withStatisticsDates = (year, dateFrom = null, dateTo = null, extra = {}) => {
  const { date_from, date_to } = clampDateRangeToYear(dateFrom, dateTo, year);
  const variables = { year, ...extra };

  if (date_from) {
    variables.date_from = date_from;
  }

  if (date_to) {
    variables.date_to = date_to;
  }

  return variables;
};
